/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Control_MessageInputs */

const en_mk_team_control_message = /** @type {(inputs: Mk_Team_Control_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide the team as work progresses`)
};

const id_mk_team_control_message = /** @type {(inputs: Mk_Team_Control_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beri arahan sepanjang jalan`)
};

/**
* | output |
* | --- |
* | "Guide the team as work progresses" |
*
* @param {Mk_Team_Control_MessageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_control_message = /** @type {((inputs?: Mk_Team_Control_MessageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Control_MessageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_control_message(inputs)
	return en_mk_team_control_message(inputs)
});